module.exports =
  '_SCORE_CARD_BOARD':
    'OUT': "OUT"
    'IN': "IN"
    'EXTRA': "EXTRA"
    'HOLE': "ホール"
    'PAR': "パー"
    'TEE_OFF_CLUB': "ティーオフクラブ"
    'FAIRWAY_HIT': "フェアウェイ"
    'PAR_ON': "パーオン"
    'SAND_SAVES': "ガードバンカー"
    'OB': "OB"
    'WATER_HAZARD': "ウォーターハザード・PN"




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/i18n/ja.coffee